import {Injectable} from '@angular/core';

// This service listens for scroll events and notifies registered listeners globally.
// Previously, scroll event handling was done individually within specific components.
// However, with 100+ components listening to scroll events, performance issues arose—
// particularly affecting measurements. This global service centralizes scroll handling to improve performance.
@Injectable({ providedIn:'root' })
export class OnDocumentClickService {
  onDocumentClickListeners: OnDocumentClick[] = [];

  constructor() {
    window.addEventListener('click', (event) => {
      this.onDocumentClick(event);
    });
  }

  onDocumentClick(event:Event): void {
      this.onDocumentClickListeners.forEach(listener => {
        if (listener && typeof listener.onDocumentClick === 'function') {
          listener.onDocumentClick(event);
        }
      });
  }

  addOnDocumentClickListener(onDocumentClick: OnDocumentClick): void {
    this.onDocumentClickListeners.push(onDocumentClick);
  }

  removeOnDocumentClickListener(onDocumentClick: OnDocumentClick): void {
    this.onDocumentClickListeners = this.onDocumentClickListeners.filter(listener => listener !== onDocumentClick);
  }
}

export interface OnDocumentClick {
  onDocumentClick(event: Event): void;
}
